import "./icon.scss";
import React, { forwardRef } from "react";

const Icon = forwardRef(
  (
    {
      children,
      className,
      disabled = false,
      onClick = () => undefined,
    },
    ref
  ) => {
    return (
      <span
        className={`icon ${
          disabled ? "disabled" : ""
        } ${className}`}
        onClick={e => !disabled && onClick(e)}
      >
        {children}
      </span>
    );
  }
);
Icon.displayName = "Icon";
export default Icon;
